/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { ComponentChildren } from 'preact';
import { cssProps } from '@oracle/oraclejet-cssprops';
import { CollectionGestureContext } from '../hooks/PRIVATE_useCollectionGestureContext';
import { classNames } from '../utils/UNSAFE_classNames';
import { preventDefaultForCurrentTarget } from './eventUtils';

const rootStyles = {
  base: cssProps`${{
    paddingLeft: '0',
    paddingRight: '0',
    margin: '1px 0 2px 0',
    position: 'relative',
    overflowX: 'hidden',
    overflowY: 'auto',
    // '-webkit-tap-highlight-color': 'transparent',
    boxSizing: 'border-box',

    display: 'flex',
    flexDirection: 'column'
  }}`,

  // TODO: These should really be applied directly to the child ListView so that the content
  // displays under the padding when scrolled, but we can't apply styles to the child collection.
  // TODO: Also need to figure out how to determine whether the collection is a ListView (in
  // the collectionRenderer case) in order to apply this styling.
  topGap: cssProps`${{
    paddingTop: 'var(--oj-c-PRIVATE-DO-NOT-USE-core-spacing-2x)'
  }}`,
  bottomGap: cssProps`${{
    paddingBottom: 'var(--oj-c-PRIVATE-DO-NOT-USE-core-spacing-2x)'
  }}`,

  loading: cssProps`${{
    minHeight: 'calc(10 * var(--oj-c-PRIVATE-DO-NOT-USE-core-spacing-4x))'
  }}`
};

type Props = {
  children?: ComponentChildren;
  hasBottomGap?: boolean;
  isLoading?: boolean;
};

export function DropdownList({ children, hasBottomGap = true, isLoading = false }: Props) {
  const styleClasses = classNames([
    rootStyles.base,
    rootStyles.topGap,
    hasBottomGap && rootStyles.bottomGap,
    isLoading && rootStyles.loading
  ]);
  return (
    <CollectionGestureContext.Provider value={'embedded'}>
      <div class={styleClasses} onMouseDown={preventDefaultForCurrentTarget}>
        {children}
      </div>
    </CollectionGestureContext.Provider>
  );
}
